import { AlertTriangle } from "@/assets";
import { getSiteProps } from "@/utils";
import { LeftArrow } from "@monsterindia/global-ui-components";
import { FC, memo } from "react";

import { profileScoreMapper } from "../utils/constant";
import { PendingStateType } from "../utils/types";

const ActionItem: FC<PendingStateType> = (props) => {
  const siteConfig = getSiteProps(window.location.hostname);

  const { name, weightage, handleModalAction } = props;
  const handleAction = (status: string) => {
    handleModalAction(status.toString(), name);
  };

  return (
    <div
      className="flex w-full cursor-pointer items-center justify-between gap-10"
      onClick={() =>
        handleAction(
          profileScoreMapper(siteConfig?.site_map === "rexmonster")?.[name]
            ?.popup,
        )
      }
    >
      <div className="my-auto flex items-center gap-2 self-stretch">
        <span>
          <AlertTriangle width={16} height={16} />
        </span>
        <div className="my-auto flex items-center gap-2 self-stretch">
          <div className="my-auto self-stretch text-sm leading-none text-black">
            {
              profileScoreMapper(siteConfig?.site_map === "rexmonster")?.[name]
                ?.label
            }
          </div>
          <div className="my-auto gap-0.5 self-stretch whitespace-nowrap rounded-3xl bg-emerald-100 px-2 py-0.5 text-xs font-bold leading-snug tracking-wide text-emerald-500">
            +{weightage}%
          </div>
        </div>
      </div>
      <LeftArrow width={16} height={16} className="-rotate-180" />
    </div>
  );
};

export default memo(ActionItem);
